<template>
  <div class="comparison-plan-modal-section">
    <common-modal-section @close="emitClose">
      <template v-slot:default>
        <div class="comparison-plan-modal-section__container">
          <div class="comparison-plan-modal-section__header">
            <p class="comparison-plan-modal-section__title">
              {{ $tc('MypagePage.MypageSwitchToPaidPlanPage.planTableTitle') }}
            </p>
          </div>
          <comparison-plan-table-parts />
        </div>
      </template>

      <template v-slot:buttons>
        <div class="comparison-plan-modal-section__footer">
          <atom-button :linkText="$tc('common.ok')" colorType="secondary" @onClick="emitClose" />
        </div>
      </template>
    </common-modal-section>
  </div>
</template>

<script>
import { defineComponent } from '@vue/composition-api'
import CommonModalSection from '@/components/common/modal/CommonModalSection.vue'
import ComparisonPlanTableParts from '@/components/common/MembershipPlan/ComparisonPlanTableParts.vue'
import AtomButton from '@/components/atoms/AtomButton.vue'

export default defineComponent({
  name: 'ComparisonPlanModalSection',
  components: { AtomButton, ComparisonPlanTableParts, CommonModalSection },
  setup(props, { emit }) {
    const emitClose = () => {
      emit('close')
    }

    return {
      emitClose,
    }
  },
})
</script>

<style scoped lang="scss">
.comparison-plan-modal-section {
  ::v-deep {
    .modal__wrapper {
      display: flex;
      flex-direction: column;
      height: 100%;
      overflow: hidden;
    }

    .modal__content {
      height: calc(100% - 100px);
    }

    .modal__buttons {
      margin: 36px 16px 16px;
    }
  }

  &__container {
    height: 100%;
    overflow-y: auto;
  }

  &__header {
    padding-top: 36px;
    padding-bottom: 16px;
    text-align: center;
  }

  &__title {
    font-size: 17px;
    font-weight: 500;
    color: #4e4e4e;
    letter-spacing: 0.04em;
  }

  &__footer {
    width: 100%;
  }
}
</style>
